import { Type } from 'class-transformer';
import { IsNotEmpty, IsString, ValidateNested } from 'class-validator';

import { Communicator } from 'src/actions/campaigns/communicator';
import createCollectionResource from 'src/actions/shared/createResource';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import { IsPropertyUniqueInStoreSlice } from 'src/actions/validators/IsPropertyUniqueInStoreSlice';

export class CustomChannelRecipient {
  id: string;

  accountId: string;
  address: string;
  type: string;

  @IsString()
  @IsNotEmpty({ message: 'Please enter the name' })
  @IsPropertyUniqueInStoreSlice('customChannelRecipients', {
    message: 'This name already exists. Please use a new name.',
  })
  name: string;

  @ValidateNested({ each: false })
  @Type(() => CustomChannelRecipientConfiguration)
  configuration: CustomChannelRecipientConfiguration;

  createdBy: Communicator;
  createdAt: string;

  updatedBy: Communicator;
  updatedAt: string;

  version: number;
}

class CustomChannelRecipientConfiguration {
  @IsNotEmpty()
  customChannelId: string;

  @IsString()
  @IsNotEmpty({ message: 'Please enter the Entry Point Address' })
  recipientAddress: string;
}

const customChannelRecipientResource = createCollectionResource<CustomChannelRecipient>({
  name: 'customChannelRecipients',

  endpoint: {
    addUrl: '/api/v1/orgs/:orgId/custom-channels/:customChannelId/endpoints',
    broadcastDeleteTopic: 'v1/orgs/:orgId/configuration/endpoints/:id/event/delete',
    broadcastTopic: 'v1/orgs/:orgId/configuration/endpoints/:id',
    collectionBroadcastDeleteTopic: 'v1/orgs/:orgId/configuration/endpoints/+/event/delete',
    collectionBroadcastTopic: 'v1/orgs/:orgId/configuration/endpoints/+',
    deleteUrl: '/api/v1/orgs/:orgId/custom-channels/:customChannelId/endpoints/:id',
    fetchAllUrl: '/api/v1/orgs/:orgId/custom-channels/:customChannelId/endpoints',
    replaceUrl: '/api/v1/orgs/:orgId/custom-channels/:customChannelId/endpoints/:id',
  },
  observerCreator: ({ actions }) => {
    return ({ dispatch }) => {
      return {
        onBroadcast(item) {
          if (item?.type === EndpointTypes.CUSTOM_CHANNEL) {
            dispatch(actions.broadcast(item));
          }
        },
        onBroadcastDelete(_, params) {
          dispatch(actions.broadcastDelete(params.id));
        },
      };
    };
  },
  options: {
    complexKey: ['id', 'configuration.customChannelId'],
    toastMessages: {
      onAdd: item => `"${item.name}" has been added.`,
      onAddFail: item => `Unable to add "${item.name}" . Please try again.`,
      onUpdate: item => `"${item.name}" has been edited.`,
      onUpdateFail: item => `Unable to edit "${item.name}". Please try again.`,
      onRemove: item => `"${item.name}" has been deleted.`,
      onRemoveFail: item => `Unable to delete "${item.name}". Please try again.`,
    },
  },
  type: CustomChannelRecipient,
});

export default customChannelRecipientResource;
